module.exports = __webpack_public_path__ + "static/media/Double Matting Logo and Text.ad47e599.png";